var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector-box"},[_c('van-cell',{attrs:{"title":_vm.item.title,"value":_vm.item.data||'无内容',"border":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }